import {createStandardAction} from "typesafe-actions";
import {AdType} from "./types";

interface IAdPayload {
    adType: AdType;
    reward?: string;
}

export const loadAds = createStandardAction('@advertisement/LOAD_ADS')<AdType>();
export const watchAds = createStandardAction('@advertisement/WATCH_ADS')<IAdPayload>();
export const showAds = createStandardAction('@advertisement/SHOW_ADS')<IAdPayload>();
export const closeAds = createStandardAction('@advertisement/CLOSE_ADS')<IAdPayload & { success: boolean }>();